import { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import FeedbackSection from "./FeedbackSection";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../../apiBase";

export default function AutoEvaluationForm() {
  const navigate = useNavigate();
  const [strengths, setStrengths] = useState("");
  const [areasOfImprovement, setAreasOfImprovement] = useState("");

  function validateForm() {
    return strengths.trim() !== "" && areasOfImprovement.trim() !== "";
  }

  async function handleSubmit() {
    if (!validateForm()) {
      alert("Por favor completá todos los campos antes de enviar.");
      return;
    }

    try {
      const response = await fetch(apiUrl("/api/autoevaluacion"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          strengths,
          areasOfImprovement
        }),
      });

      if (response.ok) {
        alert("Autoevaluación enviada con éxito");
        navigate("/"); // Redirige al home después de enviar
      } else {
        throw new Error("Error al enviar la autoevaluación");
      }
    } catch (error) {
      console.error("❌ Error:", error);
      alert("Hubo un error al enviar la autoevaluación");
    }
  }

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" mb={3}>Autoevaluación de Desempeño</Typography>

      <FeedbackSection
        strengths={strengths}
        setStrengths={setStrengths}
        areasOfImprovement={areasOfImprovement}
        setAreasOfImprovement={setAreasOfImprovement}
      />

      <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
        <Button 
          variant="contained" 
          onClick={handleSubmit}
        >
          Enviar Autoevaluación
        </Button>
      </Box>
    </Box>
  );
} 